import {PROGRAM_NAMES_ENUM} from "src/constants/workflow-instance";

export const clientId = "SwoBulkStart";
export const recipeId = "SwoBulkStart";
export const program = "SwoBulkStart";

// Soft, operator-facing guidance shown beneath the file picker in async mode.
// The async path uploads the CSV byte-identical to S3 and the per-row Lambda fans
// out via Step Functions DistributedMap, so there is no hard UI cap on row count.
// 50k is a recommended ceiling that keeps the operator's tracking-execution
// observability tractable and aligns with the backend's per-action SQS throttle.
export const BULK_START_ASYNC_RECOMMENDED_MAX_ROWS = 50000;

// Async submission is gated to a curated set of workflow definitions until the
// backend's StartBatchActionHandler contract has been validated against more recipes.
// The Tiles submission-mode selector is hidden for workflows not in this list, and
// any in-flight async selection snaps back to sync if the operator changes away.
export const BULK_START_ASYNC_ENABLED_PROGRAM_NAMES: ReadonlyArray<string> = [
    PROGRAM_NAMES_ENUM.WebsiteCompletenessMetrics,
];

export const BULK_START_ASYNC_RESULT_TEXT = {
    title: "Result",
    content: `For tracking Bulk start request, please check the status of bulk start tracking workflow execution, it's stage output will have following records:
1. totalRecords
2. failedRecords
3. OutputURL: A s3 Pre-signed URL containing details of workflow executions which failed to Start`
};
